import { checkIsLocale, Locale } from '../../../shared';

const en = {
  subscribeButtonText: 'Subscribe to plan',
  monthlyActiveUsersLabel: 'Monthly active users',
  month: '/mth',
  sms: {
    label: 'SMS count',
    text: 'SMS',
    minusLabel: 'Minus sms package',
    plusLabel: 'Plus sms package',
  },
  benefits: {
    heading: 'Key features',
    features: [
      'Boost reviews and attract more customers',
      'Automate review and referral requests with smart follow-ups',
      'Monitor reviews in real time for quick action',
      'Seamless integration with other apps, and CRM tools',
    ],
  },
};

const pl = {
  subscribeButtonText: 'Subskrybuj plan',
  monthlyActiveUsersLabel: 'Miesięczni aktywni użytkownicy',
  month: '/msc',
  sms: {
    label: 'Liczba SMS',
    text: 'SMS',
    minusLabel: 'Pakiet SMS minus',
    plusLabel: 'Pakiet SMS plus',
  },
  benefits: {
    heading: 'Kluczowe funkcje',
    features: [
      'Zwiększ liczbę opinii i przyciągnij więcej klientów',
      'Automatyzuj prośby o opinie i polecenia dzięki inteligentnym follow-upom',
      'Monitoruj opinie w czasie rzeczywistym, aby szybko reagować',
      'Bezproblemowa integracja z innymi aplikacjami i narzędziami CRM',
    ],
  },
};

const translation = (locale: Locale | string) => {
  const languages = {
    en,
    pl,
  };

  return checkIsLocale(locale) ? languages?.[locale] : en;
};

export default translation;
